var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import { UserStore } from './UserStore';
import { LoginStore } from './LoginStore';
import { NotationStore } from './NotationStore';
import { ClientViewStore } from './ClientViewStore';
import { Network } from '../services/Network';
import { loggedIn } from '../utils/Cookie';
import { CompanyStore } from '.';
export default class RootStore {
    constructor() {
        this.userStore = new UserStore(this);
        this.loginStore = new LoginStore(this);
        this.notationStore = new NotationStore();
        this.clientViewStore = new ClientViewStore(this);
        this.companyStore = new CompanyStore();
        this.network = new Network();
        this.login = (cookie) => {
            //FIXME Manual init is brittle, make stores listen to each other
            this.network.authenticate(cookie);
            this.userStore.updateUser();
            this.companyStore.fetchCompany(this.userStore.user.companyId);
            return this.clientViewStore.init();
        };
        if (loggedIn()) {
            this.login();
        }
    }
}
__decorate([
    observable
], RootStore.prototype, "userStore", void 0);
__decorate([
    observable
], RootStore.prototype, "loginStore", void 0);
__decorate([
    observable
], RootStore.prototype, "notationStore", void 0);
__decorate([
    observable
], RootStore.prototype, "clientViewStore", void 0);
__decorate([
    observable
], RootStore.prototype, "companyStore", void 0);
